import { head, isEmpty } from 'lodash';

export const buildSupportedDeliveryInfo = (deliveryTypeNames: string[]) => {
  const deliveryInfos = deliveryTypeNames.map((name) => {
    const replacedDeliveryName = name.replace(/\s/g, '');

    const deliveryInfo = {
      deliveryName: name,
      deliveryGuide: '',
      isDelivery: true,
    };

    switch (replacedDeliveryName) {
      case '샛별배송':
        deliveryInfo.deliveryGuide = '23시 전 주문 시 내일 아침 7시 전 도착\n(대구·부산·울산 샛별배송 운영시간 별도 확인)';
        break;
      case '낮배송':
        deliveryInfo.deliveryGuide = '22시 전 주문 시 내일 밤 12시 전 도착';
        break;
      case '판매자배송':
        deliveryInfo.deliveryGuide = '주문 후 2~5일 배송';
        break;
      case '미식딜리버리':
        deliveryInfo.deliveryGuide = '예약일 배송';
        break;
      case '온라인교환권':
        deliveryInfo.deliveryGuide = '알림톡 또는 문자 발송';
        deliveryInfo.isDelivery = false;
        break;
      case '항공권':
        deliveryInfo.deliveryGuide = '알림톡 또는 문자 발송';
        deliveryInfo.isDelivery = false;
        break;
      case '셀프픽업':
        deliveryInfo.deliveryGuide = '매장 직접 방문 후 수령';
        deliveryInfo.isDelivery = false;
        break;
      case '설치배송':
        deliveryInfo.deliveryGuide = '담당자 연락 후 방문';
        break;
      default:
        break;
    }

    return deliveryInfo;
  });

  const deliveryName = deliveryInfos.map(info => info.deliveryName).join('/');

  const deliveryGuide = head(deliveryInfos)?.deliveryGuide ?? '';

  const isDelivery = isEmpty(deliveryInfos.filter(info => !info.isDelivery));

  return {
    deliveryName,
    deliveryGuide,
    isDelivery,
  };
};
